import React from 'react'
import classes from "./Footer.module.css";

function Footer() {
    return (
        <div className={classes.footer}>
            <h3>Designed and Coded By</h3>
            <p>Rolando Nevarez</p>
        </div>
    )
}

export default Footer
